"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapacidadeRecursoCritico = void 0;
var bson_1 = require("bson");
var CapacidadeRecursoCritico = /** @class */ (function () {
    function CapacidadeRecursoCritico(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.recurso, recurso = _c === void 0 ? '' : _c, _d = _a.data, data = _d === void 0 ? '' : _d, _e = _a.itens, itens = _e === void 0 ? new Array() : _e;
        this._id = _id;
        this.recurso = recurso;
        this.data = data;
        this.itens = itens;
    }
    return CapacidadeRecursoCritico;
}());
exports.CapacidadeRecursoCritico = CapacidadeRecursoCritico;
//# sourceMappingURL=CapacidadesRecursoCritico.js.map